<g-nav-app-bottom
  [visible]="showNav"
  [logo]="'assets/consumer/salad_light.svg'"
  [buttons]="buttons"
  (nav)="navigate($event)"
  [active]="active"
>
  <router-outlet></router-outlet>

</g-nav-app-bottom>